import { PropsWithChildren } from 'react';
import { UseQueryResult } from 'react-query';

type LoaderProps = PropsWithChildren<{
  query: UseQueryResult | UseQueryResult[];
}>;

const isErrorType = (error: unknown): error is Error => {
  return error instanceof Error;
};

// TODO: Create proper loading and error components
const checkErrorOrLoading = (query: UseQueryResult) => {
  const { isLoading, isError, error } = query;
  if (isError)
    return isErrorType(error) ? (
      <h1>{error.message}</h1>
    ) : (
      <h1>Undefined Error!</h1>
    );

  if (isLoading || !query) return <h1>Loading...</h1>;
  return null;
};

export const Loader: React.FC<LoaderProps> = ({ query, children }) => {
  if (Array.isArray(query)) {
    for (const q of query) {
      const errorOrLoading = checkErrorOrLoading(q);
      if (errorOrLoading) return errorOrLoading;
    }
  } else {
    const errorOrLoading = checkErrorOrLoading(query);
    if (errorOrLoading) return errorOrLoading;
  }
  return <>{children}</>;
};
